<script context="module">
  import feedStore from './stores/feed';
  import { get } from 'svelte/store';
const NAMES = {
    'business': 'Business',
    'onlineBusiness': 'Business',
    'realEstate': 'Real Estate Investing',
    'investing': 'Investing',
    'health': 'Health & Wellness',
    'crypto': 'Crypto',
    'tutorials': 'Tutorials for Programming, Design and Game Development',
    'story': 'Screenwriting & Storytelling',
    'personalHealth': 'Personal Health',
    'assetProtection': 'Asset Protection',
    'nlp': 'Natural Language Processing',
    'web3': 'Web 3.0',
    'growthHackingMarketing': 'Startup Growth',
}
export function getUiFriendlyName(feedName) {
    return NAMES[feedName]
}
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const getItem = (itemID) => {
  return (get(feedStore).items || {})[itemID] || {};
}

export function getDate(dateString) {
        return new Date(dateString).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
    }
</script>